import { render, staticRenderFns } from "./TroubleshootingLocalizacao.vue?vue&type=template&id=395461c2&scoped=true&"
import script from "./TroubleshootingLocalizacao.vue?vue&type=script&lang=js&"
export * from "./TroubleshootingLocalizacao.vue?vue&type=script&lang=js&"
import style0 from "./TroubleshootingLocalizacao.vue?vue&type=style&index=0&id=395461c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395461c2",
  null
  
)

export default component.exports